import { render, staticRenderFns } from "./ImageResourceCard.vue?vue&type=template&id=e0bc5d9c&"
import script from "./ImageResourceCard.vue?vue&type=script&lang=ts&"
export * from "./ImageResourceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports